import React, { Component } from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import { StoryElement, ImageGalleryElement } from "@quintype/components";
import PropTypes from "prop-types";
import { GlideSlider } from "../../molecules/glide-slider";
import { LightBox } from "../../molecules/lightbox";

import "./styles.m.css";

class StoryCardBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      carouselIndex: 1,
      galleryItemIndex: 0
    };
    this.galleryItems = [];
    this.togglePopup = this.togglePopup.bind(this);
    this.getElementItem = this.getElementItem.bind(this);
  }
  togglePopup(index) {
    this.setState({
      showPopup: !this.state.showPopup,
      galleryItemIndex: index
    });
  }
  getElementItem(index, event) {}
  componentDidMount() {
    this.galleryItems = this.getImageGalleryElements() || [];
    this.setState({
      renderMetype: true,
      totalItems: this.galleryItems.length
    });
  }
  getImageGalleryElements() {
    const galleryItems = this.props.card["story-elements"].filter(item => item.type === "composite");
    if (galleryItems.length > 0) {
      return get(galleryItems, ["0", "story-elements"], []);
    }
  }
  render() {
    return (
      <div className={`story-page-card ${this.props.publisherAttributes.lang === "ur" ? "urdu-story-justify" : ""}`}>
        {this.props.card["story-elements"].map((element, index) => {
          switch (element.subtype) {
            case "image-gallery":
              if (element.metadata.type === "gallery") {
                return (
                  <div key={index} className="dffvfdv">
                    {element.type === "composite" ? (
                      <ImageGalleryElement
                        story={this.props.story}
                        element={element}
                        key={element.id}
                        imageAspectRatio={[1, 1]}
                        onClickHandler={this.togglePopup}
                      />
                    ) : (
                      <StoryElement story={this.props.story} element={element} externalLink={true} />
                    )}
                    <div>
                      {this.state.showPopup ? (
                        <LightBox
                          element={element["story-elements"][this.state.galleryItemIndex]}
                          closePopup={this.togglePopup}
                        />
                      ) : null}
                    </div>
                  </div>
                );
              } else {
                return (
                  this.galleryItems.length > 0 && (
                    <GlideSlider
                      story={this.props.story}
                      totalItems={this.state.totalItems}
                      getImagesFromCards={this.galleryItems}
                    />
                  )
                );
              }
            default:
              if (this.props.excludeElementId !== element.id) {
                const alsoread = {
                  ur: "یہ بھی پڑھیں : ",
                  hi: "ये भी पढ़ें : ",
                  en: "Also Read: "
                };
                return (
                  <div styleName={this.props.publisherAttributes.lang === "hi" ? "urdu-line-height" : ""}>
                    <StoryElement
                      story={this.props.story}
                      element={element}
                      externalLink={true}
                      alsoreadText={alsoread[this.props.publisherAttributes.lang]}
                    />
                  </div>
                );
              } else {
                return null;
              }
          }
        })}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], "")
  };
}

StoryCardBase.propTypes = {
  card: PropTypes.shape({
    "story-elements": PropTypes.Array
  }),
  publisherAttributes: PropTypes.object,
  story: PropTypes.object,
  excludeElementId: PropTypes.string
};

export const StoryCard = connect(
  mapStateToProps,
  null
)(StoryCardBase);
